<template>
  <section class="admin-content " id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center text-white" style="padding: 32px 0; gap: 16px;">
            <div class="header-icon-wrap">
              <i class="fe fe-users" style="font-size: 22px;"></i>
            </div>
            <div>
              <h4 class="mb-0 font-weight-bold">Duplicate Enrollees</h4>
              <small style="opacity: .8;">{{ total.total }} duplicate enrollee records found</small>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <div class="card table-card shadow mb-4">
          <div class="d-flex align-items-center px-4 pt-4 pb-3">
            <i class="fe fe-copy text-primary mr-2"></i>
            <h6 class="mb-0 font-weight-bold">Duplicate Records</h6>
            <span class="badge badge-soft-info ml-2" v-if="selected.length">{{ selected.length }} selected</span>
            <button type="button" class="btn btn-sm btn-outline-danger ml-auto" @click="deleteAll" :disabled="!selected.length">
              <i class="fe fe-trash-2 mr-1"></i> Delete Selected
            </button>
          </div>
          <div class="table-responsive">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th">Name</th>
                  <th class="table-th">Phone Number</th>
                  <th class="table-th">Type</th>
                  <th class="table-th">Agency Name</th>
                  <th class="table-th">Dependents</th>
                  <th class="table-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="client in clients" v-bind:key="client.id">

                  <td class="font-weight-bold">
                    {{ client.firstname }} {{ client.lastname }}
                    <span class="text-muted small">#{{ client.id }}</span>
                  </td>
                  <td>{{ client.phone_number }}</td>
                  <td><span class="badge badge-soft-info">{{ client.type }}</span></td>
                  <td>{{ client.agency_name }}</td>
                  <td>{{ client.dependants.length }}</td>
                  <td>
                    <div class="d-flex" style="gap:4px;">
                      <button
                        type="button"
                        @click="valuepasser(client)"
                        class="btn btn-sm btn-outline-secondary"
                      >
                        <i class="fe fe-star"></i>
                      </button>

                      <button
                        type="button"
                        @click="deleteUser(client)"
                        class="btn btn-sm btn-outline-danger"
                      >
                        <i class="fe fe-delete"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>

      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      selected: [],
      fullPage: true,
      states: "",
      total: "",
      clients: "",
      state: "",
      lga_states: "",
      register: {
        firstname: "",
        lastname: "",
        email: "",
        phone_number: "",
        type: "client",
        username: "",
        state: "",
        lga: "",
        ward: "",
        address: "",
      },
    };
  },
  beforeMount() {},
  computed: {
    //
  },

  methods: {
    deleteAll() {
      let answer = this.selected.toString();
      console.log(answer);
      this.axios
        .post(`/api/v1/auth/deletemultiple`, {
          ids: answer,
          selected_table: "users",
        })
        .then((response) => {
          console.log(response);
          this.getClients();
          this.selected = [];
          this.$toasted.success("Deleted Successfully", {
            position: "top-center",
            duration: 3000,
          });
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Error!", {
            position: "top-center",
            duration: 3000,
          });
        });
    },
    valuepasser(client) {
      this.selected.push(client.id);
    },
    getClients() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/enrollee_duplicate/407465`)
        .then((response) => {
          this.clients = response.data.data;
          this.total = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    deleteUser(client) {
      // if (confirm('Are you Sure you want to delete this user') ) {
      this.axios
        .delete(`/api/v1/auth/deleteUser/${client.id}`)
        .then((response) => {
          console.log(response);
          this.getClients();
          this.$toasted.success("Dependent deleted Successfully", {
            position: "top-center",
            duration: 3000,
          });
        })
        .catch((error) => {
          console.error(error);
          this.$toasted.error("Error!", {
            position: "top-center",
            duration: 3000,
          });
        });
      // }
    },
  },
  created() {
    this.getClients();
  },
};
</script>
